import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { ChevronDown, LayoutList } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuNav } from './menuNav';
import { toggleSection } from '../../../features/mainMenu';

export const JobLinks = ({ items, slug, groupName }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.mainMenu.sections.jobBoard);

  return (
    <Box>
      <Flex
        sx={{
          gap: '8px',
          cursor: 'pointer',
          p: '8px',
          '&:hover': { bg: 'neutral.50', transition: 'background-color 0.3s ease' },
        }}
        alignItems="center"
        onClick={() => dispatch(toggleSection('jobBoard'))}
      >
        <Box as={LayoutList} size="16px" aria-hidden="true" flex="0 0 auto" />
        <Box sx={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: 'text.main', lineHeight: '16px' }}>
          {groupName}
        </Box>
        <Box
          as={ChevronDown}
          size="16px"
          aria-hidden="true"
          flex="0 0 auto"
          sx={{
            color: 'neutral.400',
            transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.1s ease-in-out',
          }}
        />
      </Flex>
      <Flex
        pl="16px"
        sx={{
          maxHeight: isOpen ? '500px' : '0',
          opacity: isOpen ? 1 : 0,
          overflow: 'hidden',
          transition: 'all 0.1s ease-in-out',
        }}
      >
        <Box width="2px" bg="border.subtle" height="auto" mr="8px" />
        <Flex flexDirection="column" width="100%">
          {items.map(({ path, href, label }) => (
            <MenuNav key={path} path={path} href={href} label={label} slug={slug} />
          ))}
        </Flex>
      </Flex>
    </Box>
  );
};

JobLinks.propTypes = {
  items: PropTypes.array.isRequired,
  slug: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
};

export default JobLinks;
